<template>
    <Sections>
        <AppSubheader title="Stream" :parent="{title: 'Live', route: '/live'}" :dark="true">
            <ButtonSubheader
                v-if="viewers"
                class="hidden sm:block"
                buttonIcon="IconEye"
                :buttonText="`${viewers} watching`"
                :dark="true"
            ></ButtonSubheader>
            <ButtonSubheader
                v-if="viewers"
                class="block sm:hidden"
                buttonIcon="IconEye"
                :buttonText="`${viewers}`"
                :dark="true"
            ></ButtonSubheader>
            <ButtonSubheader
                v-if="isAdmin && stream"
                buttonIcon="IconEdit"
                buttonText="Edit"
                :buttonHref="$config.public.admin.stream + stream.id_stream"
                :dark="true"
            ></ButtonSubheader>
        </AppSubheader>
        <SectionStreamEmbed
            v-if="isPremiumMember"
            :stream="stream"
            @refresh="refreshStream"
        ></SectionStreamEmbed>
        <SectionJumbo
            v-else-if="stream?.id_stream"
            padding="py-16"
            :image="stream.stream_image_url"
            imageAlt="image specific to this live stream by Andy Guitar"
            imageOpacity="opacity-30"
            heading="Members Only"
            headingColor="text-white"
            content="<p>Access this stream with an AAA Membership</p>"
            contentColor="text-white"
            :buttonText="currentUser?.eligible_for_aaa_free_trial ? 'Accept Free Trial' : 'Renew Membership'"
            :buttonRoute="useContextConversion().routeMembership('live-locked-embed')"
            :textCentered="false"
        ></SectionJumbo>
        <SectionStreamDescription
            :stream="stream"
            :error="error"
        ></SectionStreamDescription>
        <SectionStreams
            v-if="stream || error"
            padding="pb-8 sm:pb-8 pt-0"
            heading="Upcoming Streams"
            :streams="upcomingStreams"
            :current="stream"
        ></SectionStreams>
        <SectionLiveReplays
            v-if="stream || error"
            color="bg-zinc-100"
            :lessons="liveReplays"
        ></SectionLiveReplays>
        <LoadingSpinner
            v-if="stream === null && !error"
        ></LoadingSpinner>
    </Sections>
</template>

<script setup>
const streamSlug = useRoute().params.streamSlug;

const {currentUser, isAdmin} = storeToRefs(useStoreAuth());
const isPremiumMember = computed(() => {
    return !!currentUser.value?.has_aaa_membership;
});

const {error, stream} = storeToRefs(useStoreStream());
const {getStream, startLiveStreamViewersPoller, stopLiveStreamViewersPoller, refreshStream, viewers} = useStoreStream();

const {upcomingStreams} = storeToRefs(useStoreStreams());
const {getStreams} = useStoreStreams();

const {lessons: liveReplays} = storeToRefs(useStoreLiveReplays());
const {getLessons: getLiveReplays} = useStoreLiveReplays();

await useLazyAsyncData('load', () => getStream(streamSlug).then(() => true));

onMounted(() => {
    startLiveStreamViewersPoller();
});

onUnmounted(() => {
    stopLiveStreamViewersPoller();
});

onMounted(() => {
    if (stream.value?.stream_status === 'active' && stream.value?.stream_playback_url && !stream.value?.stream_playback_url.includes('token')) getStream(streamSlug);
    getStreams();
    getLiveReplays();
});

useSeoStream().buildReactiveHead(stream, error);
</script>
